// React
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga";

// Components
import Modal from "react-modal";
import Pie from "../components/Pie";

// Images
import parlante from "../assets/images/speaker.png";
import arrow from "../assets/images/arrowRight-01.png";
import portada_title from "../assets/images/portada_title.png";
import portada_final from "../assets/images/portada_final.png";
import portada_kids from "../assets/images/portada_kids.png";
import portada_intermedia from "../assets/images/portada_intermedia.png";
import correct from "../assets/images/correct.png";
import star from "../assets/images/webhome.png";

// Portadas
import araña_img from "../assets/images/portadas/araña.png";
import burro_img from "../assets/images/portadas/burro.png";
import cebra_img from "../assets/images/portadas/cebra.png";
import cerdo_img from "../assets/images/portadas/cerdo.png";
import elefante_img from "../assets/images/portadas/elefante.png";
import hipopotamo_img from "../assets/images/portadas/hipopotamo.png";
import iguana_img from "../assets/images/portadas/iguana.png";
import jirafa_img from "../assets/images/portadas/jirafa.png";
import koala_img from "../assets/images/portadas/koala.png";
import mono_img from "../assets/images/portadas/mono.png";
import oso_img from "../assets/images/portadas/oso.png";
import unicornio_img from "../assets/images/portadas/unicornio.png";
import vaca_img from "../assets/images/portadas/vaca.png";
import zorro_img from "../assets/images/portadas/zorro.png";

// Gifs
import araña_gif from "../assets/images/gif/araña.gif";
import burro_gif from "../assets/images/gif/burro.gif";
import cebra_gif from "../assets/images/gif/cebra.gif";
import cerdo_gif from "../assets/images/gif/cerdo.gif";
import elefante_gif from "../assets/images/gif/elefante.gif";
import hipopotamo_gif from "../assets/images/gif/hipopotamo.gif";
import iguana_gif from "../assets/images/gif/iguana.gif";
import jirafa_gif from "../assets/images/gif/jirafa.gif";
import koala_gif from "../assets/images/gif/koala.gif";
import mono_gif from "../assets/images/gif/mono.gif";
import oso_gif from "../assets/images/gif/oso.gif";
import unicornio_gif from "../assets/images/gif/unicornio.gif";
import vaca_gif from "../assets/images/gif/vaca.gif";
import zorro_gif from "../assets/images/gif/zorro.gif";

// Videos
import araña_video from "../assets/images/videos/araña.mp4";
import burro_video from "../assets/images/videos/burro.mp4";
import cebra_video from "../assets/images/videos/cebra.mp4";
import cerdo_video from "../assets/images/videos/cerdo.mp4";
import elefante_video from "../assets/images/videos/elefante.mp4";
import hipopotamo_video from "../assets/images/videos/hipopotamo.mp4";
import iguana_video from "../assets/images/videos/iguana.mp4";
import jirafa_video from "../assets/images/videos/jirafa.mp4";
import koala_video from "../assets/images/videos/koala.mp4";
import mono_video from "../assets/images/videos/mono.mp4";
import oso_video from "../assets/images/videos/oso.mp4";
import unicornio_video from "../assets/images/videos/unicornio.mp4";
import vaca_video from "../assets/images/videos/vaca.mp4";
import zorro_video from "../assets/images/videos/zorro.mp4";

// Sounds
import narracion_0 from "../assets/sounds/narracion_0.mp3";
import click from "../assets/sounds/click.mp3";
import readWithMe from "../assets/sounds/read_1.mp3";
import readWithMe2 from "../assets/sounds/read_2.mp3";
import readAlone from "../assets/sounds/read_alone_1.mp3";
import readAlone2 from "../assets/sounds/read_alone_2.mp3";
import instructions from "../assets/sounds/instructions.mp3";
import question1 from "../assets/sounds/question1.mp3";
import question2 from "../assets/sounds/question2.mp3";
import question3 from "../assets/sounds/question3.mp3";
import aplausos from "../assets/sounds/aplausos.mp3";
import felicitaciones from "../assets/sounds/felicitaciones.mp3";
import try_again from "../assets/sounds/prueba_de_nuevo.mp3";

var sound = new Audio(click);
var audio = new Audio(narracion_0);
var read = new Audio(readWithMe);
var read2 = new Audio(readWithMe2);
var read_alone = new Audio(readAlone);
var read_alone2 = new Audio(readAlone2);
var instruction = new Audio(instructions);
var question_1 = new Audio(question1);
var question_2 = new Audio(question2);
var question_3 = new Audio(question3);
var aplausos_audio = new Audio(aplausos);
var felicitaciones_audio = new Audio(felicitaciones);
var try_again_audio = new Audio(try_again);

Modal.setAppElement("body");
export default function Home() {
  let customStyles = {
    content: {
      width: window.screen.width <= 700 ? "90%" : "30%",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      color: "#170d61",
      borderRadius: "9px",
      padding: "5px",
    },
  };

  const [showModal, setShowModal] = useState(true);
  const [step, setStep] = useState(0);
  const [correctWord, setCorrectWord] = useState(false);
  const [id, setId] = useState("");
  const [portada_animal, setPortadaAnimal] = useState(null);
  const [background_animated, setBackgroundAnimated] = useState(null);
  const [video, setVideo] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [background_color, setBackgroundColor] = useState(null);
  const [question_color, setQuestionColor] = useState("#212529");

  useEffect(() => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let game = params.lee;
    if (game === "anastasia") {
      setPortadaAnimal(araña_img);
      setId("araña");
      setVideo(araña_video);
      setBackgroundAnimated(araña_gif);
      setBackgroundColor("#fdfedf");
      setQuestions([
        {
          question: "Físicamente la araña Anastasia es:",
          options: [
            { word: "pequeña", value: true },
            { word: "peluda", value: false },
            { word: "arrugada", value: false },
          ],
        },
        {
          question: "Anastasia se caracteriza por ser:",
          options: [
            { word: "juguetona", value: false },
            { word: "tímida", value: true },
            { word: "enojona", value: false },
          ],
        },
        {
          question: "A Anastasia le gusta:",
          options: [
            { word: "cantar", value: false },
            { word: "tejer", value: true },
            { word: "cocinar", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "bernardo") {
      setPortadaAnimal(burro_img);
      setId("burro");
      setVideo(burro_video);
      setBackgroundAnimated(burro_gif);
      setBackgroundColor("#ffdea4");
      setQuestions([
        {
          question: "El burro Bernardo teje:",
          options: [
            { word: "bufandas y guantes", value: true },
            { word: "chalecos y bufandas", value: false },
            { word: "calcetines y gorros", value: false },
          ],
        },
        {
          question: "Cuando Bernardo está aburrido:",
          options: [
            { word: "lee", value: false },
            { word: "come", value: false },
            { word: "barre", value: true },
          ],
        },
        {
          question: "Bernardo sacude con:",
          options: [
            { word: "un plumero", value: false },
            { word: "un paño", value: true },
            { word: "una escoba", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "efrain") {
      setPortadaAnimal(elefante_img);
      setId("elefante");
      setVideo(elefante_video);
      setBackgroundAnimated(elefante_gif);
      setBackgroundColor("#6ccbff");
      setQuestions([
        {
          question: "Las orejas de Efraín son:",
          options: [
            { word: "gordas", value: false },
            { word: "grandes", value: true },
            { word: "puntudas", value: false },
          ],
        },
        {
          question: "Efraín usa sus orejas para:",
          options: [
            { word: "rascarse", value: false },
            { word: "volar", value: false },
            { word: "escuchar", value: true },
          ],
        },
        {
          question: "Efraín ayuda a los demás con:",
          options: [
            { word: "su trompa", value: true },
            { word: "sus orejas", value: false },
            { word: "su cola", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "irene") {
      setPortadaAnimal(iguana_img);
      setId("iguana");
      setVideo(iguana_video);
      setBackgroundAnimated(iguana_gif);
      setBackgroundColor("#a2eaff");
      setQuestions([
        {
          question: "La iguana Irene es:",
          options: [
            { word: "traviesa", value: true },
            { word: "peleadora", value: false },
            { word: "trabajadora", value: false },
          ],
        },
        {
          question: "A Irene le gusta:",
          options: [
            { word: "jugar con sus amigos", value: false },
            { word: "contar chistes", value: true },
            { word: "asustar a los demás", value: false },
          ],
        },
        {
          question: "Irene hace bromas para:",
          options: [
            { word: "que nadie esté triste", value: true },
            { word: "que todos se asusten", value: false },
            { word: "reírse de los demás", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "omar") {
      setPortadaAnimal(oso_img);
      setId("oso");
      setVideo(oso_video);
      setBackgroundAnimated(oso_gif);
      setQuestionColor("#ffffff");
      setBackgroundColor("#6d5517");
      setQuestions([
        {
          question: "Omar recorre los bosques en:",
          options: [
            { word: "otoño", value: false },
            { word: "invierno", value: false },
            { word: "verano", value: true },
          ],
        },
        {
          question: "El oso Omar come:",
          options: [
            { word: "miel y pescado", value: true },
            { word: "plantas y frutas", value: false },
            { word: "animales e insectos", value: false },
          ],
        },
        {
          question: "En invierno, el oso Omar",
          options: [
            { word: "pasea", value: false },
            { word: "duerme", value: true },
            { word: "cocina", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "ulises") {
      setPortadaAnimal(unicornio_img);
      setId("unicornio");
      setVideo(unicornio_video);
      setBackgroundAnimated(unicornio_gif);
      setBackgroundColor("#90e4ff");
      setQuestions([
        {
          question: "El unicornio Ulises vive en:",
          options: [
            { word: "un mundo de fantasía", value: true },
            { word: "cerros y montañas", value: false },
            { word: "una granja de animales", value: false },
          ],
        },
        {
          question: "En las nubes, el unicornio Ulises:",
          options: [
            { word: "duerme", value: false },
            { word: "salta", value: false },
            { word: "galopa", value: true },
          ],
        },
        {
          question: "En las noches, a Ulises lo acompaña:",
          options: [
            { word: "el bosque", value: false },
            { word: "la luna", value: true },
            { word: "el cielo", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "matias") {
      setPortadaAnimal(mono_img);
      setId("mono");
      setVideo(mono_video);
      setBackgroundAnimated(mono_gif);
      setBackgroundColor("#61dbff");
      setQuestions([
        {
          question: "Matías invita a comer a la mona porque:",
          options: [
            { word: "tiene hambre", value: false },
            { word: "está enamorado de ella", value: true },
            { word: "son buenos amigos", value: false },
          ],
        },
        {
          question: "Matías y la mona comen:",
          options: [
            { word: "manzanas y maní", value: true },
            { word: "tortas y pasteles", value: false },
            { word: "frutas y verduras", value: false },
          ],
        },
        {
          question: "Cuando está con la mona, Matías comienza a:",
          options: [
            { word: "recitar poesía", value: false },
            { word: "cantar una canción", value: true },
            { word: "leer un libro", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "cecilia") {
      setPortadaAnimal(cebra_img);
      setId("cebra");
      setVideo(cebra_video);
      setBackgroundAnimated(cebra_gif);
      setQuestionColor("#ffffff");
      setBackgroundColor("#2c0c00");
      setQuestions([
        {
          question: "La cebra Cecilia se viste con:",
          options: [
            { word: "un traje celeste y calcetas", value: true },
            { word: "un traje celeste y sombrero", value: false },
            { word: "un traje celeste y bufanda", value: false },
          ],
        },
        {
          question: "La cebra Cecilia practica:",
          options: [
            { word: "natación", value: false },
            { word: "fútbol", value: false },
            { word: "ciclismo", value: true },
          ],
        },
        {
          question: "En la semana, Cecilia practica ciclismo:",
          options: [
            { word: "tres días", value: false },
            { word: "cuatro días", value: false },
            { word: "cinco días", value: true },
          ],
        },
        ,
      ]);
    } else if (game === "jacinta") {
      setPortadaAnimal(jirafa_img);
      setId("jirafa");
      setVideo(jirafa_video);
      setBackgroundAnimated(jirafa_gif);
      setQuestionColor("#ffffff");
      setBackgroundColor("#2c458a");
      setQuestions([
        {
          question: "La jirafa Jacinta juega:",
          options: [
            { word: "cantando y bailando", value: false },
            { word: "corriendo y saltando", value: true },
            { word: "dibujando y pintando", value: false },
          ],
        },
        {
          question: "La jirafa Jacinta come:",
          options: [
            { word: "hojas y coco", value: true },
            { word: "flores y frutas", value: false },
            { word: "maní y almendras", value: false },
          ],
        },
        {
          question: "Al terminar el día Jacinta:",
          options: [
            { word: "lee", value: false },
            { word: "come", value: false },
            { word: "duerme", value: true },
          ],
        },
        ,
      ]);
    } else if (game === "hugo") {
      setPortadaAnimal(hipopotamo_img);
      setId("hipopotamo");
      setVideo(hipopotamo_video);
      setBackgroundAnimated(hipopotamo_gif);
      setBackgroundColor("#5ed9ff");
      setQuestions([
        {
          question: "El hipopótamo Hugo comió:",
          options: [
            { word: "pan y papas fritas", value: false },
            { word: "hamburguesas y helado", value: true },
            { word: "pasteles y chocolates", value: false },
          ],
        },
        {
          question: "Hugo no se podía mover porque:",
          options: [
            { word: "comió mucho", value: true },
            { word: "tenía una herida", value: false },
            { word: "estaba cansado", value: false },
          ],
        },
        {
          question: "A Hugo le dolía:",
          options: [
            { word: "el pie", value: false },
            { word: "la cabeza", value: false },
            { word: "la panza", value: true },
          ],
        },
        ,
      ]);
    } else if (game === "valeria") {
      setPortadaAnimal(vaca_img);
      setId("vaca");
      setVideo(vaca_video);
      setBackgroundAnimated(vaca_gif);
      setBackgroundColor("#60dbff");
      setQuestions([
        {
          question: "La vaca Valeria pasea en:",
          options: [
            { word: "tren", value: false },
            { word: "velero", value: true },
            { word: "avión", value: false },
          ],
        },
        {
          question: "Desde el viaje, Valeria mira el:",
          options: [
            { word: "paisaje", value: true },
            { word: "cielo", value: false },
            { word: "velero", value: false },
          ],
        },
        {
          question: "Valeria prefiere viajar en:",
          options: [
            { word: "velero", value: false },
            { word: "avión", value: true },
            { word: "camión", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "zacarias") {
      setPortadaAnimal(zorro_img);
      setId("zorro");
      setVideo(zorro_video);
      setBackgroundAnimated(zorro_gif);
      setBackgroundColor("#fbf6c3");
      setQuestions([
        {
          question: "El talento especial de Zacarías es ser un gran:",
          options: [
            { word: "deportista", value: false },
            { word: "cocinero", value: true },
            { word: "amigo", value: false },
          ],
        },
        {
          question: "Zacarías cocina con mucho:",
          options: [
            { word: "esmero", value: true },
            { word: "entusiasmo", value: false },
            { word: "orgullo", value: false },
          ],
        },
        {
          question: "Durante la tarde Zacarías cocina:",
          options: [
            { word: "zanahoria", value: false },
            { word: "zapallitos", value: false },
            { word: "arroz", value: true },
          ],
        },
        ,
      ]);
    } else if (game === "checho") {
      setPortadaAnimal(cerdo_img);
      setId("cerdo");
      setVideo(cerdo_video);
      setBackgroundAnimated(cerdo_gif);
      setBackgroundColor("#faf5c2");
      setQuestions([
        {
          question: "El chancho Checho está muy:",
          options: [
            { word: "cochino", value: true },
            { word: "contento", value: false },
            { word: "asustado", value: false },
          ],
        },
        {
          question: "Checho se ensució comiendo salsa de:",
          options: [
            { word: "tomate", value: false },
            { word: "pepino", value: true },
            { word: "cebolla", value: false },
          ],
        },
        {
          question: "Hoy Checho se comió una:",
          options: [
            { word: "sandía", value: true },
            { word: "manzana", value: false },
            { word: "torta", value: false },
          ],
        },
        ,
      ]);
    } else if (game === "karina") {
      setPortadaAnimal(koala_img);
      setId("koala");
      setVideo(koala_video);
      setBackgroundAnimated(koala_gif);
      setBackgroundColor("#fffae1");
      setQuestions([
        {
          question: "Karina practica:",
          options: [
            { word: "ciclismo", value: false },
            { word: "natación", value: false },
            { word: "karate", value: true },
          ],
        },
        {
          question: "Para practicar su deporte, Karina usa un:",
          options: [
            { word: "casco", value: false },
            { word: "kimono", value: true },
            { word: "balón", value: false },
          ],
        },
        {
          question: "Este año Karina compite contra la:",
          options: [
            { word: "gaviota", value: false },
            { word: "perdiz", value: true },
            { word: "osa", value: false },
          ],
        },
        ,
      ]);
    } else {
      window.location.href =
        "https://fundacioncrecer.net/index.php/2v-juegos-para-ejercitar-la-lectura/";
    }
  }, []);

  useEffect(() => {
    if (step === 0) {
      ReactGA.event({
        category: "le" + id,
        action: "Iniciole" + id,
      });
    } else if (step === 1) {
      ReactGA.event({
        category: "le" + id,
        action: "video1le" + id,
      });
    } else if (step === 2) {
      ReactGA.event({
        category: "le" + id,
        action: "video2le" + id,
      });
    } else if (step === 3) {
      ReactGA.event({
        category: "le" + id,
        action: "preguntasle" + id,
      });
    } else if (step === 4) {
      ReactGA.event({
        category: "le" + id,
        action: "pregunta1le" + id,
      });
    } else if (step === 5) {
      ReactGA.event({
        category: "le" + id,
        action: "pregunta2le" + id,
      });
    } else if (step === 6) {
      ReactGA.event({
        category: "le" + id,
        action: "pregunta3le" + id,
      });
    } else if (step === 7) {
      ReactGA.event({
        category: "le" + id,
        action: "finalle" + id,
      });
    }
  }, [step]);

  const playSound = () => {
    sound.currentTime = 0;
    audio.currentTime = 0;
    sound.play();
    audio.play();
  };

  const startGame = () => {
    sound.pause();
    audio.pause();
    sound.currentTime = 0;
    audio.currentTime = 0;
    setStep(1);
    playVideo();
  };

  const playVideo = () => {
    let video = document.getElementById("video");
    if (video) {
      read.pause();
      read2.pause();
      video.pause();
      read.currentTime = 0;
      read2.currentTime = 0;
      video.currentTime = 0;
    }
    read.play();
    read.addEventListener("ended", function () {
      let video = document.getElementById("video");
      video.play();
      video.addEventListener("ended", function () {
        read2.play();
        if (window.screen.width < 700) {
          video.webkitExitFullscreen();
        }
      });
    });
  };

  const playMutedVideo = () => {
    let video = document.getElementById("video");
    if (video) {
      read_alone.pause();
      read_alone2.pause();
      video.pause();
      read_alone.currentTime = 0;
      read_alone2.currentTime = 0;
      video.currentTime = 0;
    }
    read_alone.play();
    read_alone.addEventListener("ended", function () {
      let video = document.getElementById("video");
      video.play();
      video.addEventListener("ended", function () {
        read_alone2.play();
        if (window.screen.width < 700) {
          video.webkitExitFullscreen();
        }
      });
    });
  };

  const playInstructions = () => {
    instruction.currentTime = 0;
    instruction.play();
  };

  const playQuestion = (question) => {
    question.play();
  };

  const checkResponse = (response, index) => {
    let active_square = document.getElementById("frame-" + index);
    active_square.className = "QuestionBox ActiveSquare";
    if (response) {
      sound.play();
      aplausos_audio.play();
      setCorrectWord(true);
      let active_square = document.getElementById("frame-" + index);
      active_square.className = "QuestionBox ActiveSquare";

      setTimeout(function () {
        setCorrectWord(false);
        active_square.className = "QuestionBox";
        if (step === 4) {
          playQuestion(question_2);
          setStep(5);
        } else if (step === 5) {
          playQuestion(question_3);
          setStep(6);
        } else {
          felicitaciones_audio.play();
          setStep(7);
        }
      }, 3000);
    } else {
      try_again_audio.play();
      setTimeout(function () {
        active_square.className = "QuestionBox";
      }, 2000);
    }
  };

  function renderInicio() {
    return (
      <div className="Container">
        <div className="row justify-content-around ButtonRow">
          <img src={parlante} onClick={() => playSound()}></img>
          <img src={arrow} onClick={startGame}></img>
        </div>
        <div className="Portada">
          <div>
            <img src={portada_title}></img>
          </div>
          <div>
            <img src={portada_animal}></img>
          </div>
          <div>
            <img src={portada_kids}></img>
          </div>
        </div>
        <Pie />
        <Modal isOpen={showModal} style={customStyles}>
          <div className="Modal">
            <p>Hola</p>
            <p>Necesito que subas el volumen y pongas atención.</p>
            <button
              onClick={() => {
                setShowModal(false);
                playSound();
              }}
            >
              Aceptar
            </button>
          </div>
        </Modal>
      </div>
    );
  }

  function renderStep1() {
    return (
      <div className="Container">
        <div className="row justify-content-around ButtonRowVideo">
          <img src={parlante} onClick={() => playVideo()}></img>
          <img
            src={arrow}
            onClick={() => {
              let video = document.getElementById("video");
              if (video) {
                read.pause();
                read2.pause();
                video.pause();
                read.currentTime = 0;
                read2.currentTime = 0;
                video.currentTime = 0;
              }
              setStep(2);
              playMutedVideo();
            }}
          ></img>
        </div>
        <div className="VideoContainer">
          <video src={video} id="video"></video>
        </div>
        <Pie />
      </div>
    );
  }

  function renderStep2() {
    return (
      <div className="Container">
        <div className="row justify-content-around ButtonRowVideo">
          <img src={parlante} onClick={() => playMutedVideo()}></img>
          <img
            src={arrow}
            onClick={() => {
              let video = document.getElementById("video");
              if (video) {
                read_alone.pause();
                read_alone2.pause();
                video.pause();
                read_alone.currentTime = 0;
                read_alone2.currentTime = 0;
                video.currentTime = 0;
              }
              playInstructions();
              setStep(3);
            }}
          ></img>
        </div>
        <div className="VideoContainer">
          <video src={video} id="video" muted></video>
        </div>
        <Pie />
      </div>
    );
  }

  function renderStep3() {
    return (
      <div className="Container">
        <div className="row justify-content-around ButtonRow">
          <img src={parlante} onClick={() => playInstructions()}></img>
          <img
            src={arrow}
            onClick={() => {
              instruction.currentTime = 0;
              instruction.pause();
              playQuestion(question_1);
              setStep(4);
            }}
          ></img>
        </div>
        <div className="Portada_intermedia">
          <img src={portada_intermedia}></img>
        </div>
        <Pie />
      </div>
    );
  }

  function renderStep4() {
    return (
      <div>
        <div
          className="ContainerQuestionRow"
          style={{ backgroundColor: background_color }}
        >
          <div className="ContainerQuestion">
            <h2 style={{ color: question_color }}>
              {questions[step - 4].question}
            </h2>
            <div className="row justify-content-around QuestionsRow">
              {questions[step - 4].options.map(function (element, index) {
                return (
                  <div
                    className="QuestionBox"
                    key={element.word}
                    id={"frame-" + index}
                    onClick={() => {
                      checkResponse(element.value, index);
                    }}
                  >
                    <p>{element.word}</p>
                    {element.value && correctWord && (
                      <div className="CorrectDiv">
                        <img src={correct}></img>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <img className="BackgroundGif" src={background_animated}></img>
        </div>
        <Pie />
      </div>
    );
  }

  function renderFinal() {
    return (
      <div className="Container">
        <div className="row justify-content-around ButtonRow FinalRow">
          <img
            src={parlante}
            onClick={() => {
              sound.play();
              felicitaciones_audio.currentTime = 0;
              felicitaciones_audio.play();
            }}
          ></img>
        </div>
        <div className="row justify-content-around ButtonRow FinalRow">
          <img
            src={arrow}
            onClick={() => {
              ReactGA.event({
                category: "le" + id,
                action: "reiniciole" + id,
              });
              felicitaciones_audio.currentTime = 0;
              felicitaciones_audio.pause();
              startGame();
            }}
          ></img>
          <img
            src={star}
            onClick={() => {
              ReactGA.event({
                category: "le" + id,
                action: "enlacele" + id,
              });
              window.location.href =
                "https://fundacioncrecer.net/index.php/2v-juegos-para-ejercitar-la-lectura/";
            }}
          ></img>
        </div>
        <div className="Portada">
          <h1>¡Felicitaciones!</h1>
          <div>
            <img src={portada_final}></img>
          </div>
        </div>
        <Pie />
        <Modal isOpen={showModal} style={customStyles}>
          <div className="Modal">
            <p>Hola</p>
            <p>Necesito que subas el volumen y pongas atención.</p>
            <button
              onClick={() => {
                setShowModal(false);
                playSound();
              }}
            >
              Aceptar
            </button>
          </div>
        </Modal>
      </div>
    );
  }

  return (
    <>
      {step === 0 && renderInicio()}
      {step === 1 && renderStep1()}
      {step === 2 && renderStep2()}
      {step === 3 && renderStep3()}
      {(step === 4 || step === 5 || step === 6) && renderStep4()}
      {step === 7 && renderFinal()}
    </>
  );
}
